let htmlHints = {};
const htmlHintsFormatted = {};

function formatHtmlHints() {
  if (htmlHints && htmlHints.length > 0) {
    for (let i = 0; i < htmlHints.length; i += 1) {
      htmlHintsFormatted[htmlHints[i].name] = htmlHints[i].value;
    }
  }
}

if (localStorage.company && localStorage.company !== 'null') {
  htmlHints = JSON.parse(localStorage.company).htmlHints || {};

  formatHtmlHints();
}

const partnerCompanyName = htmlHintsFormatted['webshop.partner.company-name'] || '';
// const partnerRegNumber = htmlHintsFormatted['webshop.partner.registration-number'] || '';
const partnerPostalAddress = htmlHintsFormatted['webshop.partner.postall-address'] || '';
// const partnerEmailAddress = htmlHintsFormatted['webshop.partner.email-address'] || '';

const data = {
  left: `
    <div class="content" style="font-size: 11px; color: gray">
        <p><strong>Datenschutzrechtliche Information nach Art. 13 DSGVO</strong></h6>
        <p style="margin: 0 !important;"><strong>Zweck und Rechtsgrundlagen der Verarbeitung</strong></h6>
        <p>Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19.<br>
        Rechtsgrundlagen: Art. 6 Abs. 1 lit. d DSGVO (Verarbeitung personenbezogener Daten zum Schutz lebenswichtiger Interessen der betroffenen Person oder einer anderen natürlichen Person). § 5 Abs. 3 Epidemiegesetz 1950, BGBl. Nr. 186/1950 idF BGBl. I Nr. 103/2020.<br>
        Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19.</p>
        <p style="margin: 0 !important;"><strong>Verantwortlicher für die Verarbeitung der erhobenen personenbezogenen Daten</strong></p>
        <p>${partnerCompanyName}, ${partnerPostalAddress}, an die sich die betroffenen Personen zur Wahrnehmung ihrer datenschutzrechtlichen Rechte (z.B. Auskunft, Berichtigung) wenden können.</p>
    </div>
`,
  right: `
    <div class="content" style="font-size: 11px; color: gray">
        <p style="margin: 0 !important;"><strong>Die verarbeiteten personenbezogenen Daten werden zu folgendem Zweck an folgende Empfänger weitergeleitet</strong></h6>
        <p>Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19.<br>
        Empfänger: die Daten sind auf Verlangen der MA 15-Gesundheitsdienst der Stadt Wien an diese weiterzuleiten.</p>
        <p style="margin: 0 !important;"><strong>Hinweise</strong></h6>
        <p>Ihre personenbezogenen Daten werden gem. § 2 der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19 4 Wochen nach ihrer Aufnahme gelöscht.<br>
        Betroffenenrechte: Als betroffene Person haben Sie das Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten sowie auf Berichtigung, Löschung oder Einschränkung der Verarbeitung oder auf Widerspruch gegen die Verarbeitung.<br>
        Wenn die Verarbeitung auf einer Einwilligung im Sinne des Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wir weisen aber darauf hin, dass die Verarbeitung aufgrund der Einwilligung bis zum Widerruf rechtmäßig war.Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend nachgekommen wird, haben Sie die Möglichkeit einer Beschwerde bei der Österreichischen Datenschutzbehörde: Barichgasse 40-42, 1030 Wien, E-Mail: dsb@dsb.gv.at.</p>
    </div>
`,
};


export default data;



// WEBPACK FOOTER //
// ./src/components/terms-and-privacy/contact-tracking.js